/**
 * teachermate 스튜디오 랜딩 — 한결(Hangyeol) v1.5
 * 정책: shared/DESIGN-POLICY.md §9.F.1(Hero 6요소)·§9.F.3(가운데 정렬)·§9.F.4(결과 서술형 톤)
 *       §9-A.5(CTA 스타일)·§9-A.6(카피)·§9.D-7(cluster radius 단일 tier)
 * 참조 구현: ai-music-video(v1) `pages/LandingPage.tsx` — 한결 v1.4 수치 봉인
 *
 * Ghost CTA 없음 — §9-A 폐지 전환 배너 1단계(신규 앱 추가 금지).
 */
import { navigate } from "../lib/navigation";

export function LandingPage() {
  return (
    <main className="landing-page" role="main">
      <section className="landing-inner" aria-labelledby="landing-title">
        <p className="landing-label">TEACHERMATE STUDIO</p>
        <h1 id="landing-title" className="landing-title" tabIndex={-1}>
          우리 반 이야기가
          <br />
          노래와 영상이 됩니다.
        </h1>
        <p className="landing-caption">
          학생이 만든 노래에 영상을 입혀
          <br />
          한 편의 작품으로 완성합니다.
        </p>
        <div className="landing-cta-cluster" role="group" aria-label="수업 시작">
          <button
            type="button"
            className="landing-cta landing-cta-secondary"
            onClick={() => navigate("/join")}
          >
            수업 참여하기
          </button>
          <button
            type="button"
            className="landing-cta landing-cta-primary"
            onClick={() => navigate("/teacher")}
          >
            수업 만들기
          </button>
        </div>
      </section>
    </main>
  );
}
